export class ShipmentPaymentRequest {
  shipmentId: number;
  quoteId: number;
  paymentMethodId: string;
  paymentIntentId: string;
}
